module.exports = __webpack_public_path__ + "img/2.6717fe53.gif";